import { Lightning, Log, Utils } from '@lightningjs/sdk'
import { Button } from '@lightningjs/ui-components';
import { Helper } from '../../lib/helper';
import ParentalButton from '../../ui-elements/parental-button';

export default class LoginScreen extends Lightning.Component {

    static override _template() {
        return {
            Container: {
                x: (w) => w / 2,
                y: (h) => h / 2,
                mount: 0.5,
                w: 1000,
                h: 400,
                rect: true,
                color: 0xff000000,
                collision: true,
                forceZIndexContext:true,
                Label: {
                    x: 20, y: 20,
                    text: { text: 'Sign in and create Pin', fontSize: 38, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff }
                },
                Body: {
                    rect: true,
                    color: 0xff222222,
                    y: 90,
                    h: 200, 
                    collision: true,
                    w: (w)=> w,
                    FacebookBtn: {
                        x: 300,
                        y: 60,
                        collision: true,
                        zIndex:82,
                        type: ParentalButton,
                        w: 400,
                        label: 'Sign in with Gmail',
                        icon: 'images/g_logo_white-icon.png'
                    }
                },
                Footer: {
                    x: 20, y: 310,
                    text: { text: 'Note: The user data used only for display for PIN creation,  after the PIN is set succesfully all the user data is purged and user is loged out.', fontSize: 26,lineHeight: 32, textColor: 0xffffffff, fontFace: Helper.getFontFamily('Regular'), wordWrapWidth: 960 }
                }
            }
        }
    }

    override _getFocused(): Lightning.Component | null | undefined {
        return this.tag('FacebookBtn')!
    }

    override _handleBack(e: KeyboardEvent): boolean | void {
        this.signal('back')
        return true
    }

    override _handleEnter() {
        //this.showFacebookCode()
        this.signal('codeScreen')
    }

    _handleClick(target) {
        Log.info('Login Screen: _handleClick: ', target.ref)
        this.signal('codeScreen')
        //return false
        //this.onEnter(null)
        
    }
}